import { Controller as BaseController } from '@hotwired/stimulus';
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  ChartDataLabels,
);

export default class Controller extends BaseController {
  static values = {
    preReaders: Array,
    beginners: Array,
    intermediary: Array,
    fluent: Array,
    chartId: String,
  };

  connect() {
    this.selectedBimester = 1;
    this.chart = null;

    const checkCanvasAndInitialize = () => {
      const canvas = document.getElementById(this.chartIdValue);

      if (canvas) {
        this.initializeChart();
        this.updateSelectedBimester();
      } else {
        setTimeout(checkCanvasAndInitialize, 500);
      }
    };

    setTimeout(checkCanvasAndInitialize, 500);
  }

  initializeChart() {
    const fluentValue = this.getBimesterData(this.fluentValue);
    const intermediaryValue = this.getBimesterData(this.intermediaryValue);
    const beginnersValue = this.getBimesterData(this.beginnersValue);
    const preReadersValue = this.getBimesterData(this.preReadersValue);
    const isMobile = (window.innerWidth || screen.width) < 640;
    const ctx = document.getElementById(this.chartIdValue);

    if (!ctx) {
      return;
    }

    const context = ctx.getContext('2d');

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(context, {
      type: 'line',
      data: {
        labels: ['Pré-leitor', 'Leitor iniciante', 'Leitor intermediário', 'Leitor fluente'],
        datasets: [
          {
            label: 'Alunos',
            data: [preReadersValue, beginnersValue, intermediaryValue, fluentValue],
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#344054',
            borderWidth: 6,
            tension: 0.2,
            pointBackgroundColor: ['#F97066', '#FDB022', '#84E69C', '#99D4EB'],
            pointBorderColor: ['#F97066', '#FDB022', '#84E69C', '#99D4EB'],
            pointBorderWidth: 2,
            pointRadius: 10,
            pointHoverRadius: 8,
            fill: false,
          },
        ],
      },
      options: {
        aspectRatio: isMobile ? 1.2 : 640 / 250,
        maintainAspectRatio: false,
        responsive: true,
        layout: {
          padding: {
            left: 15,
            right: 15,
            top: 40,
            bottom: 10,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              display: true,
              color: 'rgba(0, 0, 0, 0.05)',
            },
            ticks: {
              display: false,
              callback: function (value) {
                return value + '%';
              },
              font: {
                size: 12,
              },
              color: '#667085',
            },
            afterFit: function (scaleInstance) {
              scaleInstance.paddingRight = 10;
              scaleInstance.paddingLeft = 10;
            },
          },
          x: {
            grid: {
              display: true,
            },
            ticks: {
              display: true,
              font: {
                size: 20,
              },
              color: '#344054',
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            display: false, // Desabilita os labels nos pontos
          },
          tooltip: {
            enabled: true,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            titleColor: '#344054',
            bodyColor: '#344054',
            borderColor: '#DFE3E8',
            borderWidth: 1,
            cornerRadius: 8,
            displayColors: false,
            callbacks: {
              label: function (context) {
                return `${context.parsed.y}% dos alunos`;
              },
            },
          },
        },
      },
    });
  }

  getBimesterData(dataArray) {
    let data = dataArray;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return 0;
      }
    }

    if (!Array.isArray(data)) {
      return 0;
    }

    const bimesterIndex = this.selectedBimester - 1;

    const value = data[bimesterIndex];
    return typeof value === 'number' ? value : 0;
  }

  selectBimester(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    const bimester = parseInt(button.dataset.bimester, 10);

    if (bimester !== this.selectedBimester) {
      this.selectedBimester = bimester;
      this.updateSelectedBimester();
      this.initializeChart();
    }
  }

  updateSelectedBimester() {
    const buttons = document.querySelectorAll('.bimester-button');

    buttons.forEach((button) => {
      const isSelected = parseInt(button.dataset.bimester, 10) === this.selectedBimester;

      const badgeEl = button.querySelector('div');

      if (badgeEl) {
        if (isSelected) {
          badgeEl.style.backgroundColor = '#101828';
          badgeEl.style.color = 'white';
          badgeEl.style.border = 'none';

          badgeEl.classList.remove('tw-bg-warning-300');
          badgeEl.classList.remove('tw-text-coolGray-950');
          badgeEl.classList.remove('tw-border-coolGray-400');
          badgeEl.classList.add('tw-border-0');
        } else {
          badgeEl.style.backgroundColor = '';
          badgeEl.style.color = '';
          badgeEl.style.border = '';

          badgeEl.classList.remove('tw-border-0');
          badgeEl.classList.add('tw-border-coolGray-400');
          badgeEl.classList.add('tw-text-coolGray-950');
        }
      }
    });
  }
}
